module.exports = __webpack_public_path__ + "static/media/downloadFileManifestIcon.f1aa9546.svg";